import * as SwitchPrimitive from '@radix-ui/react-switch';
import * as React from 'react';

import { cn } from '@/lib/utils';

export interface SwitchProps extends React.ComponentPropsWithoutRef<
  typeof SwitchPrimitive.Root
> {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}

const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  ({ className, checked, onCheckedChange, ...props }, ref) => {
    return (
      <>
        <SwitchPrimitive.Root
          ref={ref}
          checked={checked}
          onCheckedChange={onCheckedChange}
          className={cn(
            'relative h-5 w-9 cursor-pointer rounded-full p-0.5 transition-colors',
            'bg-input data-[state=checked]:bg-primary',
            className,
          )}
          {...props}
        >
          <SwitchPrimitive.Thumb
            className={cn(
              'block h-4 w-4 rounded-full bg-background',
              'will-change-transform',
              'translate-x-0.5 data-[state=checked]:translate-x-4',
              'transition-transform duration-100',
            )}
          />
        </SwitchPrimitive.Root>
      </>
    );
  },
);

Switch.displayName = 'Switch';

export { Switch };
